import type { ProjectId } from "features/shared/model/types";

import { catalog, groupDetail, groups } from "../api/urls";
export type LayeredConstructionVariant = {
  cacheRoot: string;
  catalogPath: () => string;
  catalogTypeNameKey: string;
  countLabelKey: string;
  groupDetailPath: (projectId: ProjectId, userDefinedType: string, scenario?: string) => string;
  groupsPath: (projectId: ProjectId, scenario?: string) => string;
  i18nKey: string;
  typeDbIdKey: string;
  typeDbOverrideKey: string;
};

export const buildVariant = ({
  cacheRoot,
  catalogSegment,
  catalogTypeNameKey,
  countLabelKey,
  groupSegment,
  i18nKey,
  typeDbIdKey,
  typeDbOverrideKey,
}: {
  cacheRoot: string;
  catalogSegment: string;
  catalogTypeNameKey: string;
  countLabelKey: string;
  groupSegment: string;
  i18nKey: string;
  typeDbIdKey: string;
  typeDbOverrideKey: string;
}): LayeredConstructionVariant => ({
  cacheRoot,
  catalogPath: () => catalog(catalogSegment),
  catalogTypeNameKey,
  countLabelKey,
  groupDetailPath: (projectId, userDefinedType, scenario) =>
    groupDetail(projectId, userDefinedType, groupSegment, scenario),
  groupsPath: (projectId, scenario) => groups(projectId, groupSegment, scenario),
  i18nKey,
  typeDbIdKey,
  typeDbOverrideKey,
});
